<script setup lang="ts">
import { toRef } from 'vue';
import { useI18n } from 'vue-i18n';

import { useYardTask } from '@/composables';

import type { TaskViewData } from '@nova/core';

const props = defineProps<{
  task: TaskViewData;
}>();

const { t } = useI18n();
const task = toRef(props, 'task');

const { formattedAssigneeName, formattedDueDate, dueDateTime, isOverdue } = useYardTask({
  initialTask: task
});
</script>

<template>
  <div class="d-flex flex-column gap-1 gap-sm-4 flex-sm-row">
    <div class="d-flex flex-row gap-1 align-center">
      <v-icon size="16" icon="mdi-account" />
      <span
        :class="{
          'typography-body-sm text--color-text-placeholder': !task.assignedTo,
          'typography-body-sm-bold': task.assignedTo
        }">
        {{ formattedAssigneeName }}
      </span>
    </div>
    <div v-if="dueDateTime" class="d-flex flex-row gap-1 align-center">
      <v-icon icon="mdi-timer-outline" size="16" />
      <span class="typography-body-sm-bold">{{ formattedDueDate }}</span>
      <v-chip v-if="isOverdue" size="small" class="font-weight-bold" color="error" variant="tonal">
        {{ t('checkTaskDetails.card.overdue') }}
      </v-chip>
    </div>
  </div>
</template>
